module.exports = __webpack_public_path__ + "img/S228.04afca62.jpg";